module.exports = __webpack_public_path__ + "public/SiteImages/defaultPic.png?a7d313c0";